import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSubdirectoryRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14 13H8V5H6v9a1 1 0 0 0 1 1h7v3l5-4-5-4v3z" })
});
export default SvgSubdirectoryRight;
